module.exports = __webpack_public_path__ + "img/Etebar.e6ce9ab.png";